export function modal() {
	const modalButton = document.querySelectorAll("[data-modal]");
	modalButton.forEach((modal) => {
		const modalMenu = document.querySelector(`${modal.getAttribute("href")}`);
		function modalToggle(menu) {
			if (!menu.open) {
				menu.showModal();
				return;
			}
			if (menu.open) {
				menu.close();
			}
		}

		modal.addEventListener("click", (e) => {
			modalToggle(modalMenu);
		});
		const closeButton = modalMenu.querySelector(".modal__button--close");
		closeButton.addEventListener("click", (e) => {
			modalMenu.close();
		});
	});
}
